<template lang="">
<!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Start Server Requirements Page
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
<div class="requirements-section doc-wrapper doc-inner">
    <div class="row">
        <div class="col-xl-12">
            <div class="requirements-wrapper">
                <h2 class="inner-title">Server Requirements</h2>
                <h6>Before installing the software, please ensure that your server meets the following requirements:</h6>
                <ol class="requirements-list">
                    <li><strong>PHP Version:</strong> Ensure that your server has PHP 8.0.2 or a later version installed.</li>
                    <li><strong>Laravel Framework:</strong> The software requires Laravel 9.1. Make sure your server is compatible with this version.</li>
                    <li><strong>Database:</strong> MySQL 5.1 or later version is required. Ensure MySQL is installed and accessible.</li>
                    <li><strong>Terminal Access:</strong> You need terminal access to execute commands during the installation process.</li>
                    <li><strong>Composer:</strong> Composer is required for managing PHP dependencies. Make sure it’s installed on your server.</li>
                    <li>
                        <strong>PHP Extensions:</strong>
                        <ol>
                            <li>openssl</li>
                            <li>pdo</li>
                            <li>mbstring</li>
                            <li>tokenizer</li>
                            <li>json</li>
                            <li>gd</li>
                            <li>curl</li>
                            <li>zip</li>
                            <li>zlib</li>
                            <li>fileinfo</li>
                            <li>exif</li>
                            <li>bcmath</li>
                        </ol>
                    </li>
                    <li><strong>Apache Configuration:</strong> Ensure mod_rewrite is enabled in Apache for URL rewriting.</li>
                </ol>
            </div>
        </div>
    </div>
</div>
<div class="page-change-area">
    <div class="navigation-wrapper">
        <router-link :to="{ name: 'Welcome'}" class="left"><i class="las la-angle-left me-1"></i> Welcome</router-link>
        <router-link :to="{ name: 'ServerConfiguration'}" class="right">Server Configuration <i class="las la-angle-right ms-1"></i></router-link>
    </div>
</div>
<!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    End Server Requirements Page
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
</template>
<script>
export default {
    name: 'ServerSetupRequirementsPage',
}
</script>